export default __webpack_public_path__ + "static/media/mode-46.1a5c2455.svg";